"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.refs = void 0;
var FlatFilter_1 = require("./FlatFilter");
/** Combine a set of refs into a single ref callback. */
function refs() {
    var refsToCombine = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        refsToCombine[_i] = arguments[_i];
    }
    return function (instance) {
        var e_1, _a;
        try {
            for (var _b = __values(FlatFilter_1.flatfilter(refsToCombine)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var ref = _c.value;
                if (typeof ref === "function") {
                    ref(instance);
                }
                else if (ref && typeof ref === "object" && "current" in ref) {
                    ref.current = instance;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
}
exports.refs = refs;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/helpers/Functions/Refs.js
// module id = 1648
// module chunks = 8